var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._t("default"),_c('vue-prism-editor',{attrs:{"id":_vm.id,"code":_vm.code,"language":_vm.language,"readonly":_vm.readOnly,"lineNumbers":true}})],2)}
var staticRenderFns = []

export { render, staticRenderFns }